export const GET_ALERT_CONFIG = 'GET_ALERT_CONFIG'
export const ADD_ALERT_CONFIG = 'ADD_ALERT_CONFIG'
